

export default function PunchInSession({ punchInPunchOutTime }) {

    return (

        <div>
            Sessions
            <table>
                <thead>
                    <tr className="firstTabelRow">

                        <th>Session</th>
                        <th>In Time</th>
                        <th>Out Time </th>
                        <th>Duration </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        punchInPunchOutTime?.map((ses, index) => {

                            return <tr className="table-row-main">
                                <td >{index + 1}</td>
                                <td>{ses?.InTime}</td>
                                <td>{ses?.OutTime}</td>
                                <td>{ses?.Duration}</td>
                            </tr>

                        })
                    }


                </tbody>
            </table>
        </div>
    )

}